// Imports
import { getStorage } from "src/lib/storage";
import { isDevelopment, findLink } from "src/lib/utils.js";
import { sq_personalise } from "src/lib/personalisation.js";


// Image references
const loader_gif = require('src/files/loader.gif');


(function(){
    'use strict';
    

    // Global variables

    var squiz = {
        'fn': {},
        'vars': {
            'store_id': 'gsp-'
        }
    };


    //
    // Public Functions
    //

    squiz.fn.getStorage = function(storage_id, storage_type, data_type) {
        var storage_key = squiz['vars']['store_id'] + storage_id;
        var storage_data = getStorage(storage_type, storage_key);

        switch(data_type) {
            case 'json':
                return JSON.parse(storage_data);
            default:
                return storage_data;
        }
    };

    squiz.fn.getAttributes = function() {
        return sq_personalise['vars']['attributes'];
    }

    squiz.fn.getLinkType = function(link_url) {
        var internal_link_match = '.griffith.edu.au';
        var is_internal = true;

        if(link_url === null) {
            return 'null';
        }

        if(link_url.indexOf(internal_link_match) === -1) {
            if (link_url.indexOf('http') !== -1) {
                is_internal = false;
            }
        }

        if(is_internal) {
            return 'internal';
        } else {
            return 'external';
        }
    }


    // 
    // Private Functions
    //    

    function getParentAnchor(element) {
        while (element !== null && element.tagName.toLowerCase() !== "body") {
            if (element.tagName.toLowerCase() === "a") {
            return element;
            }
            element = element.parentNode;
        }
        return null;
    };

    // Make squiz variable available to the console for debugging
    window.squiz = squiz;

    // Set the domain to work with PeopleSoft iFrames
    if (!isDevelopment()) {
        document.domain = "griffith.edu.au";
    }

    // Event listeners
    document.addEventListener('click', function (event) {
        var anchor = getParentAnchor(event.target);
        if(anchor !== null) {
            var target_link = findLink(event);
            var link_href = target_link.getAttribute('href');
            var link_target = target_link.getAttribute('target');

            var is_docs = document.querySelector('#docs-site');

            if(is_docs === null) {
                checkForSkipLinks(link_href, event);
            }            

            if(link_target === null && link_href.charAt(0) !== '#') {
                var link_type = squiz.fn.getLinkType(link_href);

                if(link_type === 'external') {
                    event.preventDefault();
                    window.open(link_href);
                }
            }
        }
    }, false);
}());

function checkForSkipLinks(link_href, event) {
    // Look for hash links
    if (link_href.charAt(0) === '#') {
        // check that the link is more than just #
        if (link_href.length > 1) {
            // Is this content or navigation?
            if (link_href.charAt(1) !== '/') {
                // Content - don't follow the link
                event.preventDefault();

                // Figure out where to go
                var target_id = link_href.replace('#', '');
                var target_element = document.getElementById(target_id);
                var is_desktop = window.matchMedia("(min-width: 992px)");
                var target_element_top;

                if (is_desktop.matches) {
                    target_element_top = target_element["scrollTop"] - 117;
                } else {
                    target_element_top = target_element["scrollTop"] - 57;
                }


                // Send user to destination element
                target_element["tabIndex"] = -1;
                target_element.focus();
                window.scrollTo(0, target_element_top);

            }
        }
    }
}

function openExternalLinkBlank(target_link, event) {
    var comp = new RegExp(location["hostname"]);

    if (comp.test(target_link["hostname"])) {
        // a link that contains the current host or the link is a relative link
    } else {
        // a link that does not contain the current host
        // link is not an id reference
        if (target_link["href"].charAt(0) !== '#') {
            // don't follow the link
            event.preventDefault();
            // Open the link in a new tab / window
            window.open(target_link["href"]);
        }
    }
}